import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const InhouseInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Inhouse Section"
    sectionKey="Inhouse"
    backRoute="/sections/inhouse"
  />
);

export default InhouseInternalTransfer;
